// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__d5vBC","inner":"Modal_inner__eMY69"};